/**
 * 运行时公共工具：校验、命令等
 * 参考 original RunCommonUtils，供 Extend 等业务模块使用
 */

import { useAndStore } from "@nuwatop/code-canvas-core";

/** 校验是否失败（存在非空错误信息） */
export function validateFailed(validateResult: any): boolean {
  if (validateResult && typeof validateResult === "object") {
    return Object.values(validateResult).some(
      (v) => typeof v === "string" && (v as string).trim().length > 0
    );
  }
  return false;
}

/** 添加命令到队列 */
export function addCommand(
  sessionId: string,
  command: { actionName: string; arg?: any }
): void {
  useAndStore.getState().addCommand(sessionId, {
    ...command,
    timestamp: Date.now(),
  });
}

/** 获取某 dataSet 的校验结果（{ [dataSetField]: errorMessage }），key = sessionId_dataSet_validate */
export function getValidateResults(
  sessionId: string,
  dataSet: string
): Record<string, string> {
  return useAndStore.getState().getValidateResults(sessionId, dataSet) ?? {};
}
